import React, { useState } from "react";
import GoogleOAuthProvider from ".";
import { ConfigContext } from "../../Config/ConfigContext";
import { useContext } from "react";
import AuthLoadingContainer from "../AuthLoadingContainer";
import GoogleLogin from "./GoogleLogin";
import http from "../../utils/http";
import { parseJwt } from "../../utils/jwt";
import { Box } from "@mui/material";
import auth from "../../utils/auth";

export default function GoogleOAuthChoice(props) {
    const [gsiScriptLoaded, setGsiScriptLoaded] = useState(false);
    //const [authSucceeded, setAuthSucceeded] = useState(false);
    const { config } = useContext(ConfigContext);

    return (
        <GoogleOAuthProvider
            onScriptLoadSuccess={() => setGsiScriptLoaded(true)}
            clientId={config.googleOAuth.clientId}
        >
            {!gsiScriptLoaded && <AuthLoadingContainer />}
            {gsiScriptLoaded &&
                <Box sx={{
                    backgroundColor: props.signInBackgroundColor || '#23102E',
                    width: '100%',
                    height: '100%'
                }}>
                    <GoogleLogin
                        ux_mode="popup"
                        parentBtnRef={props.parentBtnRef}
                        onSuccess={async (credentialResponse) => {
                            const bearerTokenObject = parseJwt(auth.getBearerToken());
                            let tenantId = bearerTokenObject.tenantId;
                            let initURL = `${config.uri.base}/auth/init`;
                            if (tenantId) initURL += `&tenantId=${tenantId}`;
                            const bearerToken = await http.get({
                                oauthResponse: JSON.stringify(credentialResponse),
                                signInPlatform: 'google',
                                signInToken: credentialResponse.credential,
                            }, initURL, { withCredentials: true });
                            auth.setBearerToken(bearerToken);
                            //setAuthSucceeded(true);
                            props.setAuthSuccess(true);
                        }}
                    />
                </Box>
            }
        </GoogleOAuthProvider>
    );
}
